import React from 'react';
import { IconType } from 'react-icons';

interface IconWrapperProps {
  icon: IconType;
  className?: string;
  size?: number;
  color?: string;
}

const IconWrapper: React.FC<IconWrapperProps> = ({ 
  icon: Icon, 
  className, 
  size, 
  color 
}) => {
  // Cast Icon as any to work around React 19 strictness with react-icons
  const IconComponent = Icon as any;
  return <IconComponent className={className} size={size} color={color} />;
};

export default IconWrapper;